export const SERVER = 'https://camino.ovh/api/';
export const SOCKET_SERVER = 'https://camino.ovh:8080';
// export const SERVER = 'http://localhost:8081/';
// export const SOCKET_SERVER = 'http://localhost:8080';